import React from 'react';

import DataModelView from '../../common/view/DataModelView';

export default class OptOutSummaryView extends DataModelView {
  getIntegratedPropertyNames() {
    return [
      'contracts',
      'isOptingLimitExceeded'
    ];
  }

  render() {
    return (
      <div>
        {this.state.contracts.map((contract) => {
          return contract.maximumOptOutCount > 0
            ? (
              <div key={contract.code} className="dx-fieldset">
                <div className="dx-fieldset-header">{contract.displayName}</div>
                <div className="dx-field">
                  <div className="dx-field-label">Opt Outs Available</div>
                  <div className="dx-field-value-static">{contract.maximumOptOutCount.toLocaleString(this.props.locale)}</div>
                </div>
                <div className="dx-field">
                  <div className={resolveAlertClass('dx-field-label', contract.isOptOutExceeded)}>Opt Outs Used</div>
                  <div className={resolveAlertClass('dx-field-value-static', contract.isOptOutExceeded)}>{contract.currentOptOutCount.toLocaleString(this.props.locale)}</div>
                </div>
                <div className="dx-field">
                  <div className={resolveAlertClass('dx-field-label', contract.isOptOutExceeded)}>Opt Outs Remaining</div>
                  <div className={resolveAlertClass('dx-field-value-static', contract.isOptOutExceeded)}>{contract.remainingOptOutCount.toLocaleString(this.props.locale)}</div>
                </div>
              </div>)
            : (<div key={contract.code} />);
        })}
      </div>
    );
  }
}

function resolveAlertClass(primaryClassName, isAlertVisible) {
  return primaryClassName + (isAlertVisible ? ' pwx-alert' : '');
}